import { Link2Icon } from 'lucide-react';
import { useGetItem } from '../../../hooks/use-items';
import { Spinner } from '@@/ui/components';

export interface ReferenceValue {
  ref: {
    eid: string;
    iid: string;
  };
}

interface ReferenceViewerProps {
  value: ReferenceValue;
}

export function ReferenceViewer({ value }: ReferenceViewerProps) {
  // TODO: Remove this post-GA and ensure data is in the proper format.
  if (typeof value !== 'object' || !value.ref) {
    return <span className='text-neutral-500 text-sm'>Invalid</span>;
  }

  const { data, isLoading } = useGetItem(value.ref.eid, value.ref.iid);

  return (
    <span className='text-neutral-950 text-sm flex items-center gap-2 text-nowrap'>
      <Link2Icon className='size-4 shrink-0' />
      {isLoading && <Spinner size='sm' />}
      {!isLoading && data && <span className='truncate min-w-[16ch]'>{data.primaryKey}</span>}
    </span>
  );
}
